import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

// Scroll-scrubbed reveal: progress is derived directly from scroll position within the
// element's own viewport window (via useScroll + useTransform), not a one-shot trigger.
// Scrolling down plays it forward; scrolling back up plays it in reverse automatically,
// since it's a pure function of the current scroll position rather than mount-time state.
export function Reveal({ children, delay = 0, y = 56, x = 0, scale = 1, rotate = 0, style, className }) {
  const ref = useRef(null);
  const stagger = Math.min(delay * 18, 25);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [`start ${88 - stagger}%`, `start ${42 - stagger}%`],
  });

  const opacity = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const translateY = useTransform(scrollYProgress, [0, 1], [y, 0]);
  const translateX = useTransform(scrollYProgress, [0, 1], [x, 0]);
  const scaleV = useTransform(scrollYProgress, [0, 1], [scale, 1]);
  const rotateV = useTransform(scrollYProgress, [0, 1], [rotate, 0]);

  return (
    <motion.div ref={ref} style={{ opacity, y: translateY, x: translateX, scale: scaleV, rotate: rotateV, ...style }} className={className}>
      {children}
    </motion.div>
  );
}
